import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

// Source de vérité UNIQUE de la région commerciale (code région + devise associée).
// Volontairement dédié à la RÉGION uniquement : la langue reste indépendante et sera
// gérée ultérieurement par un LocaleContext distinct (region !== language).
// Priorité d'initialisation : URL ?region= > choix mémorisé (localStorage) > détection IP (serveur) > NC.
const STORAGE_KEY = "securepass_commercial_region";
const RegionContext = createContext(null);

export const useRegion = () => useContext(RegionContext);

export const RegionProvider = ({ children }) => {
  const [regions, setRegions] = useState([]);
  const [region, setRegion] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    let preferred = null;
    try {
      const url = new URLSearchParams(window.location.search).get("region");
      preferred = url || localStorage.getItem(STORAGE_KEY) || null;
    } catch (e) {
      preferred = null;
    }

    // /api/plans renvoie la liste des régions + la région résolue (IP/défaut côté serveur).
    const q = preferred ? `/plans?region=${encodeURIComponent(preferred)}` : "/plans";
    api
      .get(q)
      .then(({ data }) => {
        if (!active) return;
        const regs = data?.regions || [];
        setRegions(regs);
        const codes = regs.map((r) => r.code);
        let eff;
        if (preferred && codes.includes(preferred)) {
          eff = preferred;
        } else {
          // Nettoyage d'une région mémorisée devenue invalide/obsolète.
          if (preferred) {
            try {
              localStorage.removeItem(STORAGE_KEY);
            } catch (e) {
              /* noop */
            }
          }
          eff = data?.region || (codes.includes("NC") ? "NC" : codes[0]) || null;
        }
        setRegion(eff);
        setReady(true);
      })
      .catch(() => {
        if (active) setReady(true);
      });
    return () => {
      active = false;
    };
  }, []);

  // Changement manuel : appliqué immédiatement (state React, aucun rechargement) et mémorisé.
  const selectRegion = (code) => {
    setRegion(code);
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch (e) {
      /* noop */
    }
  };

  return (
    <RegionContext.Provider value={{ regions, region, selectRegion, ready }}>
      {children}
    </RegionContext.Provider>
  );
};
